import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_MOBILE_API
axios.defaults.headers.common['withCredentials'] = true

export default axios
